import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DevolucionDineroModalService } from './service/devolucion-dinero-modal.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DevolucionDineroService } from './service/devolucion-dinero.service';
import { LoaderSubitoService } from '../../shared/components/loader-subito/service/loader-subito.service';
import { NotificationsService } from '../../shared/components/notifications/service/notifications.service';
import { PerfilUserService } from '../perfil-user/service/perfil-user.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.state';
import { setBalance } from '../perfil-user/store/balance.actions';

@Component({
  selector: 'devolucion-dinero',
  imports: [CommonModule],
  templateUrl: './devolucion-dinero.component.html',
  styleUrl: './devolucion-dinero.component.css'
})
export class DevolucionDineroComponent implements OnInit, OnDestroy {
  orderData: any = null;
  private subscription = new Subscription();

  constructor(
    public devolucionDineroModalService: DevolucionDineroModalService,
    private router: Router,
    private devolucionDineroService: DevolucionDineroService,
    private loaderService: LoaderSubitoService,
    private notificationsService: NotificationsService,
    private perfilService: PerfilUserService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.devolucionDineroModalService.orderData$.subscribe(data => {
        this.orderData = data;
      })
    );

    this.subscription.add(
      this.devolucionDineroModalService.isOpen$.subscribe(isOpen => {
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeModal(): void {
    this.devolucionDineroModalService.toggleModal(false);
    this.router.navigate(['/auth/orders']);
  }


  requestRefund(refund_type: string): void {
    this.loaderService.showLoader();
    this.devolucionDineroService.RefundType(this.orderData.orderId, refund_type).subscribe({
      next: (response) => {
        this.loaderService.hideLoader();
        this.notificationsService.addNotification({
          type: 'success',
          message: response.message
        });
        // Actualizar el balance del usuario después de la devolución exitosa
        this.perfilService.getProfile().subscribe({
          next: (profile) => {
            this.store.dispatch(setBalance({ balance: profile.data.balance }));
          },
          error: (profileErr) => {
            this.notificationsService.addNotification({
              type: 'warning',
              message: 'No se pudo actualizar el balance'
            });
          }
        });

        this.closeModal();
      },
      error: (error) => {
        this.loaderService.hideLoader();
        this.notificationsService.addNotification({
          type: 'error',
          message: 'Error al solicitar la devolución',
        });
      }
    });
  }
}
